import React from 'react';
import moment from 'moment';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import FormRadio from '../form/Radio';
import Select from '../form/Select';
import Checkbox from '../form/Checkbox';
import DatePicker from '../form/DatePicker';
import { clientHoursOfOperation } from '../../const';
import { daysOfWeek } from '../../helpers/selectOptions';

const twoDaysFromNow = moment(new Date())
  .add(2, 'days')
  .toDate();

class ClientEditWeeklySettingsModal extends React.Component {
  state = {
    client: {
      client_service_preferences: []
    },
    isPaused: false
  };

  availableStartTimes = [];

  render() {
    const { handleSubmit } = this;
    const { isOpen, closeModal } = this.props;
    const {
      client_service_preferences,
      pause_start_date,
      pause_end_date,
      menu_selection_status
    } = this.state.client;
    const { isPaused } = this.state;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 modal__heading">Weekly Service Settings</h2>

        <Formsy className="form" onValidSubmit={handleSubmit}>
          <div className="no-zone">
            {isPaused ? <div className="no-zone__overlay" /> : ''}

            {this.renderServiceSlots(client_service_preferences)}
            <div className="weekly-service__add">
              <p className="a--blue" onClick={this.handleAddTimeslot}>
                +Add Another Service
              </p>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Dish Selection</p>
                <FormRadio
                  className="radio--blue radio--large radio--full-width"
                  name="menu_selection_status"
                  placeholder=""
                  options={this.props.dishSelectOptions}
                  value={menu_selection_status}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>

          <div className={`form__row ${!isPaused ? 'form__row--spacer' : ''}`}>
            <div className="form__row-item form__row-item--full">
              <p className="simple-input__label">Pause Service</p>
              <Checkbox
                name="isPaused"
                className="checkbox--small checkbox--small-blue"
                placeholder="Pause Service"
                checked={isPaused}
                onChange={this.handleCheckboxChange}
              />
              <p className="p">
                You can pause a service for a specific amount of time, or until
                further notice.
              </p>
            </div>
          </div>

          {isPaused ? (
            <div className="form__row form__row--spacer">
              <div className="form__row-item form__row-item--half">
                <p className="p p--bold">Start Date</p>
                <DatePicker
                  name="pause_start_date"
                  value={pause_start_date}
                  minDate={twoDaysFromNow}
                  onChange={d => this.handleDateChange('pause_start_date', d)}
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <p className="p p--bold">End Date (Optional)</p>
                <DatePicker
                  name="pause_end_date"
                  value={pause_end_date}
                  minDate={twoDaysFromNow}
                  onChange={d => this.handleDateChange('pause_end_date', d)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-blue btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                value="Save"
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  renderServiceSlots(client_service_preferences = []) {
    return client_service_preferences.map((timeslot, i) =>
      this.renderServiceSlot(timeslot, i)
    );
  }

  renderServiceSlot(timeslot, index = 0) {
    return (
      <div key={index} className="weekly-service__form">
        <p className="p p--bold --inline">Weekly Service {index + 1}</p>
        <p
          className="a--red a--inline"
          onClick={() => this.handleDeleteTimeslot(index)}
        >
          Delete
        </p>

        <div className="form__row">
          <div className="form__row-item form__row-item--half">
            <p className="simple-input__label">Service Day</p>
              <Select
                name="day_of_week"
                value={timeslot.day_of_week}
                options={daysOfWeek}
                onChange={val =>
                  this.handleServiceSlotChange(index, 'day_of_week', val)
                }
                required
              />
          </div>
          <div className="form__row-item form__row-item--half">
            <p className="simple-input__label">Service Start Time</p>
            <Select
              name="start_time"
              value={timeslot.start_time}
              options={this.availableStartTimes}
              onChange={val =>
                this.handleServiceSlotChange(index, 'start_time', val)
              }
              required
            />
          </div>
        </div>
        {/* Quickest way to style this... could be done with css */}
        <div className="form__row">
          <div className="form__row-item form__row-item--half"> </div>
          <div className="form__row-item form__row-item--half">
            <p className="p p--dark-taupe">
              Chef will be in home for up to 4 hours.
            </p>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit = () => {
    const client = { ...this.state.client };
    client.pause_start_date =
      client.pause_start_date !== null
        ? client.pause_start_date.toISOString()
        : client.pause_start_date;
    client.pause_end_date =
      client.pause_end_date !== null
        ? client.pause_end_date.toISOString()
        : client.pause_end_date;

    this.props.updateClient(client);
  };

  handleChange = e => {
    const { target } = e;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const client = {
      ...this.state.client,
      [name]: value
    };

    this.setState({ client });
  };

  handleCheckboxChange = e => {
    const client = { ...this.state.client };
    const isPaused = !this.state.isPaused;
    if (!isPaused) {
      client.pause_start_date = null;
      client.pause_end_date = null;
    } else {
      // default to two days from now as start date
      client.pause_start_date = twoDaysFromNow;
    }

    this.setState({ isPaused, client });
  };

  handleDateChange = (name, date) => {
    // update service with new date
    const client = {
      ...this.state.client,
      [name]: date
    };

    this.setState({ client });
  };

  handleServiceSlotChange = (i, name, val) => {
    const client_service_preferences =
      [...this.state.client.client_service_preferences] || [];
    client_service_preferences[i] =
      val && val.value
        ? { ...client_service_preferences[i], [name]: val.value }
        : { ...client_service_preferences[i], [name]: '' };
    const client = {
      ...this.state.client,
      client_service_preferences
    };

    this.setState({ client });
  };

  handleAddTimeslot = () => {
    const client = { ...this.state.client };
    client.client_service_preferences = [
      ...client.client_service_preferences,
      {}
    ];
    this.setState({ client });
  };

  handleDeleteTimeslot = index => {
    const client = { ...this.state.client };
    client.client_service_preferences = [
      ...client.client_service_preferences.slice(0, index),
      ...client.client_service_preferences.slice(
        index + 1,
        client.client_service_preferences.length
      )
    ];
    this.setState({ client });
  };

  getHourOptions = (date = moment()) => {
    // generating hour values for selects
    const start = date
      .clone()
      .set('hour', clientHoursOfOperation.open)
      .startOf('hour');
    const end = date
      .clone()
      .set('hour', clientHoursOfOperation.close)
      .subtract(4, 'hour')
      .startOf('hour');

    let hourOptions = [];
    let increment = start.clone();
    do {
      hourOptions = [...hourOptions, this.genHourOption(increment)];
      increment.add(30, 'minutes');
    } while (increment.isBetween(start, end, null, '[]'));

    return hourOptions;
  };

  genHourOption(d) {
    const date = d.clone();
    return {
      value: date.format('HH[:]mm'),
      label: `${date.format('h[:]mma')} - ${date
        .add(4, 'hour')
        .format('h[:]mma')}`
    };
  }

  deriveState() {
    const client = { ...this.props.client };
    client.pause_start_date =
      client.pause_start_date !== null
        ? moment(client.pause_start_date)
        : client.pause_start_date;
    client.pause_end_date =
      client.pause_end_date !== null
        ? moment(client.pause_end_date)
        : client.pause_end_date;
    const isPaused = this.props.client.pause_start_date !== null;
    return { client, isPaused };
  }

  componentDidMount() {
    this.availableStartTimes = this.getHourOptions();

    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.client !== prevProps.client) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default ClientEditWeeklySettingsModal;



// WEBPACK FOOTER //
// ./src/components/client/ClientEditWeeklySettingsModal.js